/**
 * Como falar com a equipe. Fica em um lugar só: mudar aqui muda o site inteiro.
 */

export const CONTACT_PHONE = '971528063609';
export const CONTACT_DISPLAY = '+971 52 806 3609';

/** Link do WhatsApp já com a pergunta escrita, para a pessoa só apertar enviar */
export function whatsappLink(message: string): string {
  return `https://wa.me/${CONTACT_PHONE}?text=${encodeURIComponent(message)}`;
}
